export const INCIDENT_TYPES = [
  { value: 'injury', label: 'Injury' },
  { value: 'near_miss', label: 'Near Miss' },
  { value: 'property_damage', label: 'Property / Equipment Damage' },
  { value: 'vehicle', label: 'Vehicle Incident' },
  { value: 'environmental', label: 'Environmental' },
  { value: 'security', label: 'Security / Theft' },
  { value: 'other', label: 'Other' },
];

export const TREATMENTS = [
  { value: 'none', label: 'No treatment needed' },
  { value: 'first_aid', label: 'First aid on site' },
  { value: 'medical', label: 'Doctor / clinic visit' },
  { value: 'hospital', label: 'Hospital / emergency' },
];

export const PERSON_ROLES = ['Employee', 'Contractor', 'Visitor / Public'];

export const STATUS_STYLES = {
  submitted: { label: 'Submitted', className: 'bg-amber-100 text-amber-800' },
  under_review: { label: 'Under Review', className: 'bg-blue-100 text-blue-800' },
  closed: { label: 'Closed', className: 'bg-emerald-100 text-emerald-800' },
};

export const typeLabel = (v) => INCIDENT_TYPES.find((t) => t.value === v)?.label || v;
export const treatmentLabel = (v) => TREATMENTS.find((t) => t.value === v)?.label || v;
export const assetUrl = (path) => `${process.env.REACT_APP_BACKEND_URL}${path}`;
